// REPORTING STATUS
export const GET_REPORTING_STATUSES = '/reporting_status/query';
export const GET_REPORTING_STATUS = '/reporting_status/';
export const POST_REPORTING_STATUS = '/reporting_status/';
export const PUT_REPORTING_STATUS = '/reporting_status/';
export const DELETE_REPORTING_STATUS = '/reporting_status/';
export const CHECK_REPORTING_STATUS_EXISTS = '/reporting_status/query';
